import { API, API_POST } from "../../config";

export const DeleteContact = (id, status) => {
  const f = new FormData();
  f.append("id", id);
  f.append("status", status);

  return API_POST(API.deletecontact, f);
};
